import React, { Fragment, useState, useEffect } from "react";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";

// Material-UI Icon
import SearchIcon from "@material-ui/icons/Search";

// Custom Style
import { transferListStyle } from "../../styles/jss/components/transferList/transferListStyle";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const useStyles = makeStyles((theme) => transferListStyle(theme));

const TransferList = (props) => {
  const classes = useStyles();
  const {
    recipientType,
    reciptentChipAdd,
    reciptentChipRemove,
    listData,
    userType,

    leftToUserRcpt,
    setLeftToUserRcpt,
    rightToUserRcpt,
    setRightToUserRcpt,

    leftCcUserRcpt,
    setLeftCcUserRcpt,
    rightCcUserRcpt,
    setRightCcUserRcpt,
  } = props;

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  const leftChecked = intersection(checked, listData);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const saveRcptData = async (leftList, rightList, userType) => {
    let right = rightList.map((obj) => ({
      ...obj,
      userType: userType,
    }));
    if (recipientType === "TO") {
      setRightToUserRcpt(
        rightToUserRcpt === null
          ? right
          : right.concat(
              rightToUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftToUserRcpt(leftList);
    } else if (recipientType === "CC") {
      setRightCcUserRcpt(
        rightCcUserRcpt === null
          ? right
          : right.concat(
              rightCcUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftCcUserRcpt(leftList);
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    saveRcptData(
      not(left, leftChecked),
      right.concat(leftChecked),
      userType
    ).then(() => {
      reciptentChipAdd("USER", leftChecked);
    });
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    saveRcptData(
      left.concat(rightChecked),
      not(right, rightChecked),
      userType
    ).then(() => {
      reciptentChipRemove("USER", rightChecked);
    });
  };

  const returnRecipientAfterAction = (rightUser, listOfUser) => {
    let rightArr = [];
    if (rightUser && rightUser.length > 0) {
      for (var i = 0; i < rightUser.length; i++) {
        rightArr.push(rightUser[i].site_user_seq);
      }
    }
    let internalList = listOfUser;
    internalList = listOfUser.filter(
      (obj) => !rightArr.includes(obj.site_user_seq)
    );
    return internalList;
  };
  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "all items selected" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />

      <Divider />

      <List className={classes.list} dense component="div" role="list">
        {items.map((res) => {
          const labelId = `transfer-list-all-item-${res.user_seq}-label`;

          return (
            <ListItem
              key={res.user_seq}
              role="listitem"
              button
              // onClick={handleToggle(res)}
            >
              <ListItemIcon>
                <Checkbox
                  onClick={handleToggle(res)}
                  checked={checked.indexOf(res) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>

              <ListItemText
                id={labelId}
                primary={res.fullname}
                secondary={res.company.company_name}
              />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );

  const quickSearch = (event) => {
    const keyWord = event.target.value !== null ? event.target.value : "";
    let filterResult = "";
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(rightToUserRcpt, listData);
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "CC") {
      let internalList = returnRecipientAfterAction(rightCcUserRcpt, listData);
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    }

    setLeft(filterResult);
  };

  useEffect(() => {
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(rightToUserRcpt, listData);
      leftToUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftToUserRcpt);
      rightToUserRcpt === null
        ? setRight([])
        : setRight(
            rightToUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "CC") {
      let internalList = returnRecipientAfterAction(rightCcUserRcpt, listData);
      leftCcUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftCcUserRcpt);
      rightCcUserRcpt === null
        ? setRight([])
        : setRight(
            rightCcUserRcpt.filter((item) => item.userType === userType)
          );
    } else {
      setLeft([]);
      setRight([]);
    }
  }, []);
  return (
    // console.log("Recipient Type | Variable: recipientType (TransferList.js)"),
    // console.log(recipientType),

    // console.log("User List | Variable: listData (TransferList.js)"),
    // console.log(listData),

    // console.log("Checked User | Variable: checked (TransferList.js)"),
    // console.log(checked),

    // console.log("Left Checked User | Variable: leftChecked (TransferList.js)"),
    // console.log(leftChecked),

    // console.log("Right Checked User | Variable: rightChecked (TransferList.js)"),
    // console.log(rightChecked),

    // console.log("User List : Left | Variable: left (TransferList.js)"),
    // console.log(left),

    // console.log("User List Right | Variable: right (TransferList.js)"),
    // console.log(right),

    // console.log("Left To User Data | Variable: leftToUserRcpt (TransferList.js)"),
    // console.log(leftToUserRcpt),

    // console.log("Right To User Data | Variable: rightToUserRcpt (TransferList.js)"),
    // console.log(rightToUserRcpt),

    // console.log("Left CC Group Data | Variable: leftCcGroupRcpt (TransferList.js)"),
    // console.log(leftCcUserRcpt),

    // console.log("Right CC Group Data | Variable: rightCcGroupRcpt (TransferList.js)"),
    // console.log(rightCcUserRcpt),

    // console.log("---------------------------------------------------------------------------------"),

    <Fragment>
      <div className={classes.searchBar}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>

          <InputBase
            onChange={quickSearch}
            placeholder="Quick Search"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      </div>

      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item xs={5} md={5}>
          {customList("Choices", left)}
        </Grid>

        <Grid item xs={2} md={2}>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>

            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={5} md={5}>
          {customList("Chosen", right)}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default TransferList;
